<template>
  <template v-if="routeLoading">
    <progress class="visually-hidden" aria-label="Loading page"></progress>
    <div class="route-progress" aria-hidden="true">
      <span class="route-progress-bar"></span>
    </div>
  </template>
</template>

<script setup lang="ts">
import { watch } from 'vue'
import { routeLoading } from '../../services/route-loading'

watch(routeLoading, isLoading => {
  document.documentElement.classList.toggle('route-loading', isLoading)
})
</script>

<style lang="scss">
html.route-loading,
html.route-loading * {
  cursor: progress;
}
</style>

<style lang="scss" scoped>
.route-progress {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 2100;
  height: 3px;
  overflow: hidden;
  background: rgba(27, 113, 73, 0.15);
  pointer-events: none;
}

.route-progress-bar {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 40%;
  background: #1b7149;
  animation: route-progress-slide 1.1s ease-in-out infinite;
}

@keyframes route-progress-slide {
  0% {
    transform: translateX(-100%);
  }

  100% {
    transform: translateX(250%);
  }
}

@media (prefers-reduced-motion: reduce) {
  .route-progress-bar {
    width: 100%;
    animation: none;
  }
}
</style>
